import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App.js';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  HttpLink
} from '@apollo/client';
import jwt_decode from 'jwt-decode';
import Session from './utils/Session.js';


// eslint-disable-next-line no-undef
// const httpLink = new HttpLink({ uri: "http://localhost:4005" });
const httpLink = new HttpLink({ uri: process.env.REACT_APP_ENDPOINT });

// Setup the header for the request
const middlewareAuthLink = new ApolloLink((operation, forward) => {
  const headers = {
    'x-access-token': Session.secureValue('x-access-token') || Session.value('x-access-token'),
    'x-refresh-token': Session.secureValue('x-refresh-token') || Session.value('x-refresh-token')
  };
  const refresh = Session.secureValue('x-force-refresh') || '';
  if (refresh) {
    headers['x-force-refresh'] = refresh;
    Session.secureRemove('x-force-refresh');
    Session.secureRemove('x-access-token');
  }
  operation.setContext({
    headers
  });

  return forward(operation);
});

// After the backend responds, we take the x-refresh-token and x-refresh-token from headers if it exists, and save it in the session.
const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext();
    const { response: { headers } } = context;

    if (headers) {
      const refreshToken = headers.get('x-refresh-token');
      const accessToken = headers.get('x-access-token');
      if (accessToken) {

        try {
          const decoded = jwt_decode(accessToken);
          const isExpired = decoded.exp <= Math.floor(Date.now() / 1000);
          if (!isExpired && decoded.id) {

            Session.setSecureValue('x-access-token', accessToken);
            Session.setSecureValue('x-refresh-token', refreshToken);
          } else {
            // Session.secureRemove('x-access-token');
            // Session.secureRemove('x-refresh-token');
            // Session.secureRemove('user');
          }
        } catch (err) {
          // err
          console.log(err)
          Session.secureRemove('x-access-token');
          Session.secureRemove('x-refresh-token');
          Session.secureRemove('user');
        }
      }
    }

    return response;
  });
});


const client = new ApolloClient({
  link: ApolloLink.from([middlewareAuthLink, afterwareLink, httpLink]),
  cache: new InMemoryCache(),
  name: 'School',
  version: '2.0'
});

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<ApolloProvider client={client}>
  <App />
</ApolloProvider>);